module.exports = __webpack_public_path__ + "img/crema o unguento oftalmico.4c64af44.png";